import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { computed, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private breakpointObserver = inject(BreakpointObserver);
  private isMobile = signal<boolean>(false);

  constructor() {
    // From 960px and above switch to "desktop view"
    // Breakpoints.Small is 600px-959px
    // We want mobile view below 960px (when Medium+ don't match)
    this.breakpointObserver
      .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .pipe(
        takeUntilDestroyed(),
        tap((value: BreakpointState) => this.isMobile.set(!value.matches))
      )
      .subscribe();
  }

  public isMobileView = computed<boolean>(() => this.isMobile());
}
